import React from "react";

import L from "leaflet";

import {
  Map,
  TileLayer,
  ScaleControl,
  ZoomControl,
  LayerGroup
} from "react-leaflet";

import Control from "react-leaflet-control";

import "leaflet/dist/leaflet.css";

import "./styles.scss";

import { sections, sectionMembers, memorials } from "lib/memorials";
import { cssColors as colors } from "lib/colors";

import MapItem from "./mapItem";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default class LeafletMap extends React.Component {
  startViewport = null;

  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth < 800,
      maxZoom: 20,
      minZoom: 9,
      viewport: {},
      popUpState: false
    };

    this.trackPopupClicks = this.trackPopupClicks.bind(this);
  }

  trackPopupClicks(spot) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "Interactions",
      event_action: "click",
      event_label: "Tipp: " + spot.name
    });
  }

  saveStartViewport = viewport => {
    if (this.startViewport === null) {
      this.startViewport = viewport;
    }
  };

  getSectionBounds(section) {
    // console.log(section);
    // we don't have the right bounds yet
    // TODO remove this block
    if (section === "modern") {
      return L.latLngBounds([
        [46.954, 7.4427],
        [46.945, 7.45]
      ]).pad(1);
    }

    if (section === "headless") {
      return L.latLngBounds([46.952995, 7.443234], [46.952389, 7.458681]).pad(
        1
      );
    }

    if (section === "natural") {
      return L.latLngBounds([46.940717, 7.444864], [46.939354, 7.454276]).pad(
        1
      );
    }
    // for comparison we want all lat/lon-arrays
    // of items in current section in one flat array
    const positions = memorials
      .filter(m => {
        return sectionMembers[section].includes(m.name);
      })
      .map(i => {
        return i.positions.map(p => p.position);
      })
      .flat();

    // top left point has highest lat-long diff-value
    // bottom right point has smallest lat-long diff-value
    const diffMask = positions.map(el => el[0] - el[1]);

    const topLeftIndex = diffMask.findIndex(el => el === Math.max(...diffMask));

    const bottomRightIndex = diffMask.findIndex(
      el => el === Math.min(...diffMask)
    );

    const topLeft = positions[topLeftIndex];
    const bottomRight = positions[bottomRightIndex];

    // console.log(section, [topLeft, bottomRight]);
    // console.log(topLeft, bottomRight);
    return L.latLngBounds([topLeft, bottomRight]).pad(0.14);
  }

  render() {
    const position = [46.948895, 7.440025];

    return (
      <Map
        // eslint-disable-next-line react/jsx-handler-names
        onViewportChanged={this.saveStartViewport}
        // viewport={center: [], zoom: 0} // will react to changes
        scale={position}
        bounds={this.getSectionBounds(this.props.currentSection)} // will react to changes
        zoomControl={false}
        center={position}
        tap={false}
        maxZoom={this.state.maxZoom}
        minZoom={this.state.minZoom}
        dragging={!this.state.isMobile}
        // dragging
        touchZoom
        scrollWheelZoom={false}
        ref="leafletMap"
        // zoom={12.5}
        zoomDelta={0.3}
        zoomSnap={0}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> Der Bund'
          url="https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png"
          // url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
          // https://leaflet-extras.github.io/leaflet-providers/preview/index.html
        />

        {/* SECTION MEISTAUFGESTELLTEN */}
        {this.props.currentSection === sections.MOST ? (
          <LayerGroup ref={sections.MOST}>
            <MapItem
              name="haller"
              isCurrent={this.props.currentItems === "haller"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name="kocher"
              isCurrent={this.props.currentItems === "kocher"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION UMGEZOGENE */}
        {this.props.currentSection === sections.MOVED ? (
          <LayerGroup ref={sections.MOVED}>
            <MapItem
              name="erlach"
              isCurrent={this.props.currentItems === "erlach"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />

            {/* <MapItem
              name="gotthelf"
              isCurrent={this.props.currentItems === "gotthelf"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            /> */}

            <MapItem
              name="bubenberg"
              isCurrent={this.props.currentItems === "bubenberg"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name="zähringer"
              isCurrent={this.props.currentItems === "zähringer"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION KOPFLOSE */}
        {this.props.currentSection === sections.HEADLESS ? (
          <LayerGroup ref={sections.HEADLESS}>
            <MapItem
              name="weinzäpfli"
              isCurrent={this.props.currentItems === "weinzäpfli"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            {/* <MapItem
              name="wehrmänner"
              isCurrent={this.props.currentItems === "wehrmänner"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            /> */}
            <MapItem
              name="vonwerdt"
              isCurrent={this.props.currentItems === "vonwerdt"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name="aargauerstalden"
              isCurrent={this.props.currentItems === "aargauerstalden"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION NATÜRLICHE */}
        {this.props.currentSection === sections.NATURAL ? (
          <LayerGroup ref={sections.NATURAL}>
            <MapItem
              name="kopp"
              isCurrent={this.props.currentItems === "kopp"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />

            {/* <MapItem
              name="kuenzi"
              isCurrent={this.props.currentItems === "kuenzi"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />

            <MapItem
              name="studer"
              isCurrent={this.props.currentItems === "studer"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
           /> */}
          </LayerGroup>
        ) : null}

        {/* SECTION INTERATIONAL */}
        {this.props.currentSection === sections.WORLD ? (
          <LayerGroup ref={sections.WORLD}>
            <MapItem
              name="bolivar"
              isCurrent={this.props.currentItems === "bolivar"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />

            <MapItem
              name="rizal"
              isCurrent={this.props.currentItems === "rizal"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />

            {/*            <MapItem
              name="titulescu"
              isCurrent={this.props.currentItems === "titulescu"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
*/}
            <MapItem
              name="lenin"
              isCurrent={this.props.currentItems === "lenin"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />

            <MapItem
              name="mazzini"
              isCurrent={this.props.currentItems === "mazzini"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />

            <MapItem
              name="refugianten"
              isCurrent={this.props.currentItems === "refugianten"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIFTH}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION MODERNE */}
        {this.props.currentSection === sections.MODERN ? (
          <LayerGroup ref={sections.MODERN}>
            <MapItem
              name="korenhuisbrug"
              isCurrent={this.props.currentItems === "korenhuisbrug"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name="einstein"
              isCurrent={this.props.currentItems === "einstein"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
            <MapItem
              name="stadionuhr"
              isCurrent={this.props.currentItems === "stadionuhr"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name="dank"
              isCurrent={this.props.currentItems === "dank"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION FRAUEN */}
        {this.props.currentSection === sections.WOMEN ? (
          <LayerGroup ref={sections.WOMEN}>
            <MapItem
              name="weltpost"
              isCurrent={this.props.currentItems === "weltpost"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name="telegraphen"
              isCurrent={this.props.currentItems === "telegraphen"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
            <MapItem
              name="minerva"
              isCurrent={this.props.currentItems === "minerva"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name="seiler"
              isCurrent={this.props.currentItems === "seiler"}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        <ScaleControl position="bottomleft" metric imperial={false} />
        <ZoomControl position="topright" />
        <Control position="topleft" />
      </Map>
    );
  }
}
